export const AUTHORITY_LEVELS = [
  { value: "legislation", label: "Legislation" },
  { value: "regulation", label: "Regulation" },
  { value: "standard", label: "Standard" },
  { value: "company_policy", label: "Company Policy" },
  { value: "guideline", label: "Guideline" },
  { value: "informational", label: "Informational" },
] as const;
